<template>
    <div class="centered-block">
        <div class="text-center">
            <h1 class="page-title">404</h1>
            <p>Oups ! Cette page n'existe pas</p>
            <p>Tu sembles avoir visé à côté de la cible 🎯</p>

            <router-link to="/" class="cta-link">← Retour à l'accueil </router-link>
        </div>
    </div>
</template>